module.exports = __webpack_public_path__ + "img/archiveicon.f3ebe0be.svg";